import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import GoogleFontLoader from "react-google-font-loader";

ReactDOM.render(
	<BrowserRouter>
		<GoogleFontLoader
			fonts={[
				{
					font: "Livvic",
					weights: [300, 400, 500, 600, 700],
				},
				{
					font: "Open Sans",
					weights: [300, 400, 500, 600, 700],
				},
			]}
			subsets={["cyrillic-ext", "greek"]}
		/>
		<App />
	</BrowserRouter>,
	document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
